export default function About() {
  return (
    <section id="about" className="border-b-2 border-black bg-white">
      <div className="mx-auto max-w-4xl px-4 py-20 md:px-8 md:py-28">
        <div className="mb-3 text-xs font-bold uppercase tracking-[0.25em] text-[var(--kay-pink)]">
          About Us
        </div>
        <h2 className="font-display text-4xl uppercase leading-none sm:text-5xl md:text-6xl">
          A local team
          <br />
          that <span className="text-[var(--kay-pink)]">actually cares.</span>
        </h2>
        <div className="mt-6 space-y-5 text-neutral-700 sm:text-lg">
          <p>
            Kay's Waste Management is a woman-founded, family-owned business
            built on one simple idea: waste clearance shouldn't be a headache.
            From your first call to the moment we drive away, we want you to
            feel looked after.
          </p>
          <p>
            We turn up when we say we will, treat your home (or your
            customer's home) with respect, and clear away everything neatly.
            Customer care isn't a bolt-on for us — it's the whole reason we
            started.
          </p>
          <p className="font-script text-3xl text-[var(--kay-pink)]">
            — Kay &amp; the team
          </p>
        </div>
      </div>
    </section>
  );
}
